export default "__VITE_ASSET__b9be7483__"